import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import editIcon from '../../assets/1@3x.png';
import icCircle from '../../assets/circle.png';
import icSeru from '../../assets/ic_exclamation.png';
import { createMuiTheme, Fab, MuiThemeProvider, Snackbar, Switch, TableCell, Tooltip, Typography, withStyles } from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import EditMasterSpesialis from './editMasterSpesialis';
import AddMasterSpesialis from './addMasterSpesialis';
import api from '../api';
import CloseImage from '../../assets/ic_close.png';
import Loader from 'react-loader-spinner'
import MuiAlert from '@material-ui/lab/Alert';
import { TramRounded } from '@material-ui/icons';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);
const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});
const style = {
    position: "sticky",
    zIndex: 110
};

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function MasterSpesialis(props) {
    const [dataTable, setDataTable] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [visibleDetail, setVisibleDetail] = React.useState(false)
    const [visibleCreate, setVisibleCreate] = React.useState(false)
    const [visibleStatus, setVisibleStatus] = useState(false)
    const [id, setID] = React.useState("")
    const [detail, setDetail] = useState([])
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [create, setCreate] = React.useState(true);
    const [read, setRead] = React.useState(true);
    const [update, setUpdate] = React.useState(true);
    const [deleted, setDeleted] = React.useState(TramRounded);


    React.useEffect(() => {
        props.setShowNotif(true)
        getDataTable()
    }, [])

    const handleSeeDetail = (data) => {
        setID(data.rowData[4])
        setVisibleDetail(true)
    }

    const onClose = () => {
        setVisibleDetail(false)
        setVisibleCreate(false)
    }
    const getDataTable = () => {
        api.create().getListMasterSpesialis().then(response => {
            console.log(response)
            if (response.data) {
                if (response.data.status === true) {
                    let dataTable = []
                    response.data.data.map((item, index) => {
                        // console.log(item);
                        dataTable.push([
                            index + 1,
                            item.name,
                            item.status === 1 ? 'Active' : 'Inactive',
                            item.deleted_at === null ? 'Active' : 'Inactive',
                            item.id,
                        ])
                    })
                    setDataTable(dataTable)
                    setLoading(false)
                } else {
                    setLoading(false)
                    setOpenAlert(true)
                    setMessageAlert(JSON.stringify(response.data.data))
                    setStatusAlert('warning')
                }

            } else {
                setLoading(false)
            }
        })
    }

    const handleStatus = ({ rowData }) => {
        setVisibleStatus(true)
        setDetail(rowData)
    }

    const changeStatus = () => {
        let payload = {
            "id": detail[4],
            "activeinactive": detail[3] === "Active" ? 0 : 1
        }
        console.log(payload);
        api.create().updateMasterSpesialis(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setVisibleStatus(false)
                    setMessageAlert(response.data.message)
                    setStatusAlert("success")
                    getDataTable()
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const columns = [{
        name: "No",
        options: {
            filter: false,
            sortThirdClickReset: true,
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ textAlign: 'center' }}>
                        {val}
                    </div>
                )
            }
        }
    },
    {
        name: "",
        label: "Spesialisasi",
        options: {
            sortThirdClickReset: true
        }
    },
    {
        name: "",
        label: "Status",
        options: {
            sortThirdClickReset: true
        }
    },
    {
        name: "Aksi",
        options: {
            filter: false,
            customHeadRender: (columnMeta) => (
                <TableCell style={{ ...style, top: 0, backgroundColor: 'white', }}>
                    <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt', fontWeight:'bold' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {update && (
                            <LightTooltip title={`Edit`} arrow>
                                <button
                                    style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent',
                                        marginRight: 20
                                    }
                                    }
                                    onClick={() => {
                                        handleSeeDetail(tableMeta)
                                    }}
                                >
                                    <img src={editIcon} style={{ width: 30, height: 30 }} />
                                </button>
                            </LightTooltip>
                        )}

                        {deleted && (
                            <LightTooltip title={`${tableMeta.rowData[3]}`} arrow>
                                <button style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent'
                                }}
                                    onClick={() => {
                                        handleStatus(tableMeta)
                                    }}>
                                    <IconSwitch checked={tableMeta.rowData[3] === 'Active' ? true : false} />
                                </button>
                            </LightTooltip>
                        )}
                    </div>
                )
            }
        }
    },
    {
        name: "",
        options: {
            display: false,
            filter: false
        }
    },
    {
        name: "",
        options: {
            display: false,
            filter: false
        }
    },
    {
        name: "",
        options: {
            display: false,
            filter: false
        }
    },
    ];

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {loading ? loadingComponent : null}
            {create && (
                <div style={{ width: '40%', position: 'absolute', left: 10, top: 15, zIndex: '10' }}>
                    <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                    >
                        <div onClick={() => { setVisibleCreate(true) }} style={{ display: 'flex' }}>
                            <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                            <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 8, color: 'white' }}>Tambah</Typography>
                        </div>
                    </button>
                </div>
            )}
            {/* <div style={{ marginTop: 20, boxShadow: '5px 2px 10px 0 #999999', borderRadius: 30 }}> */}
            {read && (
                <div>
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={dataTable}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
            )}
            {/* </div> */}
            {visibleCreate && (
                <AddMasterSpesialis
                    onClose={onClose}
                    getData={getDataTable}
                />
            )}
            {visibleDetail && (
                <EditMasterSpesialis
                    onClose={onClose}
                    id={id}
                    getData={getDataTable}
                />
            )}

            {visibleStatus && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle" style={{ borderRadius: 15, width: 540, backgroundColor: '#f2fff9' }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ backgroundColor: '#f2fff9', margin: '-50px 0px 0px 0px', borderRadius: 70, width: 115, height: 115, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ backgroundImage: `url(${icCircle})`, width: 103.8, height: 103.8, backgroundRepeat: 'no-repeat', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={icSeru} style={{ width: 50, height: 50 }} />
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda yakin ingin mengganti status Spesialis tersebut?</Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '10px', padding: '20px' }}>
                            <div
                                onClick={() => setVisibleStatus(false)}
                                style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                            </div>
                            <div
                                onClick={() => changeStatus()}
                                style={{ height: 32, width: 150, backgroundColor: '#278863', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )

}